export const ChatPath = {
  Chat: '/chat',
} as const
